<template>
    <div>
        <FieldActionItem
            v-for="action in actions" :action="action" :key="action.name"
            @delete="onActionDelete"
            @update="onActionUpdate"
            class="mt-2"/>

        <AppDropdown
            id="available-actions"
            :data="availableActions"
            @select="onActionAdd"
            :search="{ show: true, property: 'label', caseSensitive: false }">
            <template slot="menu-button">
                <div class="text-purple clickable" :class="{ 'mt-2': actions.length !== 0}">
                    Add
                </div>
            </template>
            <template #item="{ item }">
                {{ item.label }}
            </template>
        </AppDropdown>
    </div>
</template>

<script>
import {fieldActionModels} from '../../../../../../../../types/document-viewer/field/modules/action'
import FieldActionItem from './FieldActionItem'

export default {
    name: 'FieldActionsEditor',
    components: {FieldActionItem},
    props: {
        field: {
            type: Object,
            required: true
        }
    },
    computed: {
        actions() {
            return this.field.actions || []
        },

        availableActions() {
            return fieldActionModels.filter(a => a.available.validator(this.field) &&
                !this.actions.some(action => action.name === a.name))
        }
    },
    methods: {
        onActionUpdate(action) {
            const actions = _.cloneDeep(this.actions)
            const idx = actions.findIndex(v => v.name === action.name)
            if (idx !== -1) {
                actions[idx] = action
            }
            this.$emit('update', actions)
        },

        onActionDelete(action) {
            const actions = _.cloneDeep(this.actions)
            const idx = actions.findIndex(v => v.name === action.name)
            if (idx !== -1) {
                actions.splice(idx, 1)
            }
            this.$emit('update', actions)
        },

        onActionAdd(action) {
            const actions = _.cloneDeep(this.actions)
            actions.push({name: action.name})
            this.$emit('update', actions)
        }
    }
}
</script>

<style scoped>

</style>
